module.exports = __webpack_public_path__ + "static/media/OpenSans.c4d82460.eot";